module.exports = __webpack_public_path__ + "static/media/icon_credit_card.2b44c660.svg";